module.exports = __webpack_public_path__ + "static/media/tiptw.8f51282d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/report/tiptw.png
// module id = 369
// module chunks = 0